/**
 * ResultadoOpcionesField — Select dropdown with options from ExamenTipo.
 *
 * Requirements: 3.3
 */

import { useTranslation } from "react-i18next";

import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ResultadoOpcionesFieldProps {
  value: string;
  onChange: (value: string) => void;
  opciones: string[];
  error?: string;
}

export function ResultadoOpcionesField({
  value,
  onChange,
  opciones,
  error,
}: ResultadoOpcionesFieldProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Label htmlFor="valor_opcion">{t("procesamiento.captura.valor_opcion")}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className={error ? "border-destructive" : ""}>
          <SelectValue placeholder={t("procesamiento.captura.valor_opcion_placeholder")} />
        </SelectTrigger>
        <SelectContent>
          {opciones.map((opcion) => (
            <SelectItem key={opcion} value={opcion}>
              {opcion}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error && <p className="text-xs text-destructive">{error}</p>}
      {opciones.length === 0 && (
        <p className="text-xs text-muted-foreground">{t("procesamiento.captura.sin_opciones")}</p>
      )}
    </div>
  );
}
